import React from "react";
import "./Marque.css"; // External CSS file

const Marque = () => {
  const items = [
    "Comprehensive Planning",
    "Expert Guidance",
    "Local Experience",
    "Customer Support",
    "Sustainability Efforts",
    "Memorable Itineraries",
  ];

  return (
    <div className="marquee-container">
      <div className="marquee-content">
        {/* Render items twice to create seamless scrolling */}
        {items.map((item, index) => (
          <span key={`item-${index}`} className="marquee-item">
             <div style={{ display: 'flex', gap: '20px' }}>
      <div>✸</div>
      <div> {item} </div>
           </div>  
          </span>
        ))}
        {items.map((item, index) => (
          <span key={`item-copy-${index}`} className="marquee-item">
            <div style={{ display: 'flex', gap: '20px' }}>
      <div>✸</div>
      <div> {item} </div>
           </div> 
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marque;
